"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMediaQuery = function (breakpointValue) {
    var _a = react_1.useState(false), matches = _a[0], setMatches = _a[1];
    react_1.useEffect(function () {
        var media = window.matchMedia("(min-width: " + breakpointValue + ")");
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function () { return setMatches(media.matches); };
        window.addEventListener('resize', listener);
        return function () { return window.removeEventListener('resize', listener); };
    }, [matches, breakpointValue]);
    return matches;
};
exports.default = useMediaQuery;
//# sourceMappingURL=use-media-query.hook.js.map